export default "__VITE_ASSET__1ce21fbd__"